import React, { createContext, useContext, useEffect, useRef } from "react";
import { io } from "socket.io-client";

const WebSocketContext = createContext(null);

export const WebSocketProvider = ({ children }) => {
  const socketRef = useRef(null);
  const socketUrl = process.env.REACT_APP_WEB_SOCKET_URL ?? "";
  useEffect(() => {
    // Initialize the WebSocket connection
    socketRef.current = io(socketUrl, {
      transports: ["websocket"],
    });

    socketRef.current.on("connect", () => {
      console.log("Connected to WebSocket server");
    });

    socketRef.current.on("connect_error", (error) => {
      console.error(`Connection error: ${error}`);
    });

    socketRef.current.on("disconnect", () => {
      console.log("Disconnected from WebSocket server");
    });

    socketRef.current.on("reconnect_attempt", (attemptNumber) => {
      console.log(`Reconnect attempt #${attemptNumber}`);
    });

    socketRef.current.on("reconnect_failed", () => {
      console.log("Reconnection failed after max attempts");
    });

    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
      }
    };
  }, [socketUrl]);

  return (
    <WebSocketContext.Provider value={socketRef}>
      {children}
    </WebSocketContext.Provider>
  );
};

export const WebSocketConsumer = WebSocketContext.Consumer;
export const useWebSocket = () => useContext(WebSocketContext);
